// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper from "swiper/bundle";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

import "./reviews-list.scss";

const reviewsList = () => {
    let allReviewsList = document.querySelectorAll(".reviews-list");

    if (!allReviewsList.length) return;

    allReviewsList.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            slidesPerView: 1,
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                },
                370: {
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                },
                485: {
                    slidesPerView: 1.4,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 2.1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                },
                1025: {
                    slidesPerView: 2.4,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 3.1,
                    spaceBetween: 30,
                },
            },

            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },

            pagination: {
                el: pagination,
                clickable: true,
                dynamicBullets: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

export default reviewsList;
